import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import {isEmpty} from "./helpers";

const DeviceContext = createContext({ isMobile: false, isWhosfan: false, embedHost: "", isIframe: false });

export const useMobile    = () => useContext(DeviceContext).isMobile;
export const useIsWhosfan = () => useContext(DeviceContext).isWhosfan;
export const useEmbedHost = () => useContext(DeviceContext).embedHost;
export const useIsIframe = () => useContext(DeviceContext).isIframe;

const EMBED_HOST_KEY = "embed_host";
const IFRAME_CALL_KEY = "iframe_call";

// URL에서 읽되, 없으면 sessionStorage에서 복구
function getInitialContextSessionData(key) {
    if (typeof window === "undefined") return "";
    const params = new URLSearchParams(window.location?.search || "");
    const fromUrl = params.get(key);
    const fromStore = window.sessionStorage.getItem(key);
    const val = (fromUrl ?? fromStore ?? "").trim();

    // URL에 있으면 최신값으로 저장
    if (fromUrl) window.sessionStorage.setItem(key, fromUrl);
    return val;
}

// URL에 embed_host 빠져 있으면 현재 주소에 다시 붙여줌(선택사항)
function ensureParamInUrl(key, param) {
    if (!param) return;
    const url = new URL(window.location.href);
    if (!url.searchParams.get(key)) {
        url.searchParams.set(key, param);
        window.history.replaceState(null, "", url.toString());
    }
}

function hasWhosfan(s) {
    return typeof s === "string" && s.toLowerCase().includes("whosfan");
}

function computeIsWhosfan(embedHost) {
    const hostname      = window.location?.hostname || "";
    const isWhosfanHost = hostname.includes("whosfan.com");
    const isBstageHost  = hostname.includes("bstage.in");
    const isWhosfanApp  =
        hasWhosfan(navigator.userAgent) ||
        hasWhosfan(navigator.vendor) ||
        hasWhosfan((window.opera?.toString?.() ?? "")) ||
        hasWhosfan(embedHost);

    return isWhosfanHost || isBstageHost || isWhosfanApp;
}

function computeIsIframe(iframeCall) {
    // iframeCall 값이 존재하면 true
    // window.location?.pathname 에 "iframe" 이 존재하면 true
    const pathname      = window.location?.pathname || "";
    const isIframe = pathname.includes("iframe");
    return !isEmpty(iframeCall) || isIframe ;
}

export function MobileProvider({ children }) {
    // ✅ 최초 1회만 결정하고 고정
    const [embedHost] = useState(getInitialContextSessionData(EMBED_HOST_KEY));
    const [iframeCall] = useState(getInitialContextSessionData(IFRAME_CALL_KEY));

    // 필요하면 URL에 항상 유지 (SPA 라우팅으로 빠지는 경우 대비)
    useEffect(() => {
        ensureParamInUrl(EMBED_HOST_KEY, embedHost);
        ensureParamInUrl(IFRAME_CALL_KEY, iframeCall);
    }, [embedHost, iframeCall]);

    // ✅ isWhosfan은 embedHost(고정) 기준으로만 계산 → 라우팅/리사이즈 영향 X
    const isWhosfan = useMemo(() => computeIsWhosfan(embedHost), [embedHost]);
    const isIframe = useMemo(() => computeIsIframe(iframeCall), [iframeCall]);

    // ✅ 모바일 여부는 리사이즈에 따라 변함
    const [rawIsMobile, setRawIsMobile] = useState(() => window.innerWidth <= 768);
    useEffect(() => {
        const onResize = () => setRawIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    // 요구사항: isWhosfan이 true면 모바일이라도 false 취급
    const isMobile = rawIsMobile;


    // console.log("%s : %s", EMBED_HOST_KEY, embedHost)
    console.log("%s : %s", IFRAME_CALL_KEY, iframeCall)
    // console.log("isWhosfan : %s", isWhosfan)
    console.log("isIframe : %s", isIframe)

    return (
        <DeviceContext.Provider value={{ isMobile, isWhosfan, embedHost, isIframe }}>
            {children}
        </DeviceContext.Provider>
    );
}
